import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=bced060e&scoped=true&"
import script from "./TableForm.vue?vue&type=script&lang=js&"
export * from "./TableForm.vue?vue&type=script&lang=js&"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=bced060e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced060e",
  null
  
)

export default component.exports